<template>
	<section class="DashboardPage LeaveDashboardPage">
		<div class="requests card">
			<div class="title">VERLOFAANVRAGEN</div>
			<div class="requests table">
				<div class="headers row">
					<span>Medewerker</span>
					<span>Vestiging</span>
					<span>Verlof</span>
					<div></div>
					<div></div>
				</div>
				<div class="row" v-for="userAvailability in leaveRequestAvailabilities">
					<span>{{ userAvailability.user.display_name }}</span>
					<span>{{ userAvailability.user.branch }}</span>
					<span>{{ parseDate(userAvailability.date_from) }}</span>
					<span>{{ userAvailability.date_from !== userAvailability.date_till ? parseDate(userAvailability.date_till) : '' }}</span>
					<div class="buttons">
						<button class="cross button" @click="approveRequest(userAvailability.id, 'no')">
							<XIcon></XIcon>
						</button>
						<button class="check button" @click="approveRequest(userAvailability.id, 'yes')">
							<CheckIcon></CheckIcon>
						</button>
					</div>
				</div>
			</div>
		</div>
		<div class="approved card">
			<div class="title">TOEGEWEZEN VERLOF</div>
			<div class="approved table">
				<div class="headers row">
					<span>Medewerker</span>
					<span>Vestiging</span>
					<span>Verlof</span>
					<div></div>
				</div>
				<div class="row" v-for="userAvailability in leaveApprovedAvailabilities">
					<span>{{ userAvailability.user.display_name }}</span>
					<span>{{ userAvailability.user.branch }}</span>
					<span>{{ parseDate(userAvailability.date_from) }}</span>
					<span>{{ parseDate(userAvailability.date_till) }}</span>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import CheckIcon from "vue-feather-icons/icons/CheckIcon";
import {client} from "../../store";
import {parseDate} from "../../utils";
import XIcon from "vue-feather-icons/icons/XIcon";

export default {
	name: "Leave",
	components: {XIcon, CheckIcon},

	data() {
		return {
			leaveRequestAvailabilities: [],
			leaveApprovedAvailabilities: []
		}
	},

	methods: {
		parseDate,

		getRequestingUsers() {
			client.query(`
				query($filter: String) {
					getUserAvailabilities(filter: $filter) {
						id
						type
						date_from
						date_till
						user {
							id
							display_name
							phone
							branch
						}
					}
				}`, {
					filter: "requested_leave"
				}
			).then(result => {
				this.leaveRequestAvailabilities = result.getUserAvailabilities;
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Verlofaanvragen ophalen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het ophalen van de informatie"
				});
			});
		},

		getApprovedUsers() {
			client.query(`
				query($filter: String) {
					getUserAvailabilities(filter: $filter) {
						id
						type
						date_from
						date_till
						user {
							id
							display_name
							phone
							branch
						}
					}
				}`, {
					filter: "approved_leave"
				}
			).then(result => {
				this.leaveApprovedAvailabilities = result.getUserAvailabilities;
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Toegewezen verlof ophalen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het ophalen van de informatie"
				});
			});
		},

		approveRequest(id, approved) {
			client.query(`
				mutation($id: ID!, $approved: String) {
					updateUserAvailability(id: $id, approved: $approved)
				}`, {
					id: id,
					approved: approved
				}
			).then(() => {
				this.$notify({
					group: "app",
					title: "Beschikbaarheid aangepast",
					type: "success",
					text: "Succesvol aangepast"
				});

				this.getRequestingUsers();
				this.getApprovedUsers();
			}).catch((error) => {
				console.error(error);
				this.$notify({
					group: "app",
					title: "Beschikbaarheid aanpassen mislukt",
					type: "error",
					text: "Er is een fout opgetreden bij het aanpassen van de beschikbaarheid"
				});
			});
		}
	},

	beforeMount() {
		this.getRequestingUsers();
		this.getApprovedUsers();
	}
}
</script>

<style lang="scss" scoped>
.LeaveDashboardPage {
	height: calc(100% - 44px);
	padding: 24px;

	.requests.card {
		margin-bottom: 24px;
	}

	.card {
		background-color: #FFF;
		padding: 24px;
		border: 3px solid #e0e0e0;

		.title {
			color: #1aae9f;
			font-weight: 800;
			font-size: 1.5em;
			margin-bottom: 24px;
		}

		.table {
			display: flex;
			flex-direction: column;
			gap: 8px;

			.headers {
				font-weight: 800;
				margin-bottom: 8px;
			}

			.row {
				display: flex;
				flex-direction: row;

				div {
					width: 88px;
					display: flex;
					flex-direction: row;
					gap: 8px;

					.button {
						display: block;
						padding: 8px 8px 4px 8px;
						border-radius: 4px;
						border: none;
						color: #FFF;

						&.cross {
							background-color: #d3455b;
						}
						&.check {
							background-color: #1aae9f;
						}
					}
				}
			}
		}
	}

	.requests.table > div > span {
		width: calc((100%  - 88px) / 4);
		display: inline-flex;
		align-items: center;
	}

	.approved.table > div > span {
		width: calc(100% / 4);
		display: inline-flex;
		align-items: center;
	}
}
</style>
